import React from 'react'
import RangeSlider from 'react-range-slider-input'
import { formatNumber } from '../../../utils'
import FilterIcon from '../../common/icons/FilterIcon'
import PaneHeader from '../panes/PaneHeader'

const IncomeRangeSlider = ({ id, label, min, max, displayMax, step, value, onChange }) => {
  return (
    <div className='filter__slider'>
      <label className='filter__trans-label text-regular' htmlFor={id}>
        <span className='filter__trans-text'>{label}</span>
        <RangeSlider
          id={id}
          min={min}
          max={max}
          step={step}
          value={value}
          onInput={onChange}
          className='filter__range-slider'
        />
      </label>

      <div className='filter__slider-min-max'>
        <span className='filter__slider-val filter__slider-val--min'>
          {formatNumber(value[0])}
        </span>
        <span className='filter__slider-val filter__slider-val--max'>
          {formatNumber(value[1] !== undefined ? value[1] : displayMax)}
        </span>
      </div>
    </div>
  )
}

const IncomeFilterPopup = ({
  populationRange,
  populationMax,
  onPopulationChange,
  incomeRange,
  incomeMax,
  onIncomeChange,
  onClose,
  onApply,
  onReset
}) => {
  const safePopulationMax = Math.max(0, populationMax || 0)
  const safeIncomeMax = Math.max(0, incomeMax || 0)
  const populationSliderMax = safePopulationMax === 0 ? 1 : safePopulationMax
  const incomeSliderMax = safeIncomeMax === 0 ? 1 : safeIncomeMax

  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault()
    onApply()
  }

  return (
    <div className='filter'>
      <PaneHeader
        icon={FilterIcon}
        title='Filters'
        onClose={onClose}
      />
      <form className='filter__form' onSubmit={handleSubmit}>
        <ul className='filter__list'>
          <li className='filter__item'>
            <IncomeRangeSlider
              id='income-population'
              label='Population'
              min={0}
              max={populationSliderMax}
              displayMax={safePopulationMax}
              step={1}
              value={populationRange}
              onChange={onPopulationChange}
            />
          </li>
          <li className='filter__item'>
            <IncomeRangeSlider
              id='income-median'
              label='Median HH income'
              min={0}
              max={incomeSliderMax}
              displayMax={safeIncomeMax}
              step={1}
              value={incomeRange}
              onChange={onIncomeChange}
            />
          </li>
        </ul>
        <div className='filter__controls'>
          <div className='filter__controls-top'>
            <button type='button' className='filter__btn filter__btn--cancel' onClick={onClose}>Cancel</button>
            <button type='submit' className='filter__btn filter__btn--apply'>Apply filters</button>
          </div>
          <button type='button' className='filter__btn--reset' onClick={onReset}>Reset all filters</button>
        </div>
      </form>
    </div>
  )
}

export default IncomeFilterPopup
